const { container } = require('@/container');

/**
 * Ensures all the supplied fields are present and not-empty in the supplied data.
 * The requiredFields param has keys that should match the data, and its values are lang keys to display to the user
 * in the event of an error.
 *
 * @param {Object<string, string>} requiredFields
 * @param {object} data
 */
const validateRequiredFields = (requiredFields, data) => {
    const missingFields = Object.keys(requiredFields).filter((key) => {
        const value = data[key];
        return value === undefined || value === null || value === '';
    });

    if (missingFields.length > 0) {
        const errorMessage = missingFields.map((key) => {
            const name = container.langService.getText(requiredFields[key]).toLowerCase();
            return `Please enter a value for the ${name} field.`;
        }).join(' ');

        throw new Error(errorMessage);
    }
};

module.exports = {
    validateRequiredFields,
};
